import { render, staticRenderFns } from "./PresetSettings.vue?vue&type=template&id=652686aa&scoped=true&"
import script from "./PresetSettings.vue?vue&type=script&lang=ts&"
export * from "./PresetSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PresetSettings.vue?vue&type=style&index=0&id=652686aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652686aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VDivider,VIcon,VSubheader})
